import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import axios from "axios";
import DoubleBarChart from "../DoubleBarChart";
import { scrollToSection } from "../helpers/links";

const BARS = [
  {
    dataKey: "expected",
    fill: "#17a34a",
    name: "Expected",
  },
  {
    dataKey: "actual",
    fill: "#2463eb",
    name: "Actual",
  },
];

const ExpectedExpensesChart = ({ expensesPath }) => {
  const [data, setData] = useState(null);

  const fetchData = () => {
    let url = `${expensesPath}.json?kind=expected_expenses`;
    axios
      .get(url, {
        headers: ReactOnRails.authenticityHeaders({}),
      })
      .then((response) => {
        const { data } = response.data;
        setData(data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    scrollToSection("bar_expected_expenses_chart");
  }, [data]);

  if (!data) {
    return null;
  }

  return (
    <div
      className="px-2 flex flex-col items-center justify-center mt-4"
      id="bar_expected_expenses_chart"
    >
      <div className="max-w-xl w-full">
        <DoubleBarChart
          data={data}
          title="Actual expenses vs expected"
          bars={BARS}
        />
      </div>
    </div>
  );
};

ExpectedExpensesChart.propTypes = {
  expensesPath: PropTypes.string.isRequired,
};

export default ExpectedExpensesChart;
